import axios from '../../../axios';
import IPostgreJobsAnalyticsPayload from '../../AnalyticsService/types/IPostgreJobsAnalyticsPayload';
import ICommunicationAnalytics from '../types/ICommunicationAnalytics';

const url = 'wsreporting/api/communications';

export const callsMadeByDirectionAndSource = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}/made_by_direction_and_source`, searchFilter);

export const totalCallsMadeInCurrentDay = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}/total_calls_made_in_current_day`, searchFilter);

export const hourlyCallsMadeBarChart = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}/made_by_hourly_bar_chart`, searchFilter);

export const getCommunicationsByRecruiters = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}/communications_by_recruiters`, searchFilter);

export const getCommunicationsByDirection = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}/communications_by_direction`, searchFilter);

export const getTotalCommunicationsBySource = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}/total_communications_by_source`, searchFilter);

export const getTotalCommunicationsByCallStatus = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}/communications_by_calls_status`, searchFilter);

export const getCommunicationCallsAnalyticsPostgres = (
  searchQuery: IPostgreJobsAnalyticsPayload,
  abortController: AbortController
) =>
  axios.post(
    `/analyticsreportingapp/api/composable-analytics/communications/calls/${searchQuery.type}`,
    searchQuery,
    abortController
  );

export const getCommunicationSmsAnalyticsPostgres = (
  searchQuery: IPostgreJobsAnalyticsPayload,
  abortController: AbortController
) =>
  axios.post(
    `/analyticsreportingapp/api/composable-analytics/communications/sms/${searchQuery.type}`,
    searchQuery,
    abortController
  );
